import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TsPieceComponent } from '../shared/ts-piece/ts-piece.component';
import { ImageSlotComponent } from '../shared/image-slot/image-slot.component';
import {
  SOLUTIONS,
  Solution,
  SOLUTION_BASE,
  solutionTotal,
  solutionBreakdown,
  solutionPieces,
  SolutionImageSlot,
} from './solutions.data';

/**
 * Listado de soluciones por sector (`/soluciones`). Filas destacadas + cards
 * compactas, servidas desde `solutions.data.ts`. Cada "Ver esta solución" lleva
 * a su detalle `/soluciones/:slug`; la banda "A tu medida" deriva a `/servicios`.
 */
@Component({
  selector: 'app-soluciones',
  standalone: true,
  imports: [RouterLink, TsPieceComponent, ImageSlotComponent],
  templateUrl: './soluciones.component.html',
  styleUrl: './soluciones.component.scss',
})
export class SolucionesComponent {
  readonly solutions = SOLUTIONS;
  readonly featured = SOLUTIONS.filter(s => s.featured);
  readonly compact = SOLUTIONS.filter(s => !s.featured);
  readonly base = SOLUTION_BASE;

  /**
   * Hipótesis de orden (README del handoff): false = "A tu medida" al final
   * (sector primero); true = al principio. Invertible con este flag, sin rehacer.
   */
  readonly aMedidaPrimero = false;
  /** Mostrar el total desglosado en las filas de sector. */
  readonly mostrarTotales = true;

  total(s: Solution): number {
    return solutionTotal(s);
  }

  breakdown(s: Solution): string {
    return solutionBreakdown(s);
  }

  /** Piezas del icono de una solución (base + un `tr` por módulo/complemento). */
  pieces(s: Solution): { color: string; outline: boolean }[] {
    return solutionPieces(s);
  }

  /** Ruta de la captura de una solución (undefined → marcador). */
  img(s: Solution, slot: SolutionImageSlot): string | undefined {
    return s.images[slot];
  }
}
